import(/* webpackMode: "eager" */ "/opt/buildhome/repo/platform/app/global-error.tsx");
